let _token: string | null = null;

export const setToken = (token: string | null) => {
    _token = token;

    if (token) {
        sessionStorage.setItem("token", token);
    } else {
        sessionStorage.removeItem("token");
    }
};

export const getToken = () => {
    if (!_token) {
        _token = sessionStorage.getItem("token");
    }
    return _token;
};